<template>
	<span class="cell-wrapper">{{ date }}</span>
</template>

<script>
import moment from 'moment';

export default {

	props: [ 'row', 'field' ],

	computed: {
		date: function() {
			const date = moment(this.row[ this.field.slug ]);
			if (!date.isValid()) {
				return 'N/A';
			}

			return date.format('MMMM D, YYYY');
		}
	}
};
</script>
